// #region [types]

import {
  T車載データ,
  T車輌ETCカード,
  T車輌給油カード,
} from "../../../service/truck/TSyaryo"

/**
 * 車載データ
 */
export type TSyasaiDataTable = {
  車輌車載リスト: TSyasaiData[]
}

export type TSyasaiData = T車載データ &
  Partial<{
    row_id?: string
  }>
/**
 * 標準交換（ｋｍ）
 */
export type THyojunKoukan = Partial<{
  標準交換距離オイル: string
  標準交換距離エレメント: string
}>

export type TETC = Partial<{
  ETC設置区分: string | null
  ETC車載器メーカー: string
  ETC車載器シリアルNO: string
}>

/**
 * ETCカード
 */
export type TEtcCardTable = {
  ETCカードリスト: TEtcCardData[]
}

export type TEtcCardData = T車輌ETCカード & {
  row_id?: string
}

/**
 * 給油カード
 */
export type TKyuyuCardTable = {
  給油カードリスト: TKyuyuCardData[]
}

export type TKyuyuCardData = T車輌給油カード & {
  row_id?: string
}

export const initialSyasaiDataTableState: TSyasaiDataTable = {
  車輌車載リスト: [],
}
export const initialEtcCardDataTableState: TEtcCardTable = {
  ETCカードリスト: [],
}
export const initialKyuyuCardDataTableState: TKyuyuCardTable = {
  給油カードリスト: [],
}

export const initialHyojunKoukanState: THyojunKoukan = {
  標準交換距離オイル: "",
  標準交換距離エレメント: "",
}

export const initialETCState: TETC = {
  ETC設置区分: "",
  ETC車載器メーカー: "",
  ETC車載器シリアルNO: "",
}

//#endregion
